// Action Types
export const types = {
  UPDATE_DOCUMENT: "UPDATE_DOCUMENT",
};

// Action Creator
export const updateDocument = (doc) => ({
  type: types.UPDATE_DOCUMENT,
  payload: doc, // Pass the whole document as payload
});
